import React from "react";
import { useNavigate } from 'react-router-dom';

export const Footer = ()=>{

    const navigate = useNavigate();

    const goToLogin = async () => {
        navigate('/login');
    };
    return(
        <footer id="sticky-footer" className="flex-shrink-0 py-4  text-white-50">
        <div className="container text-center d-flex flex-column">
          <small>Copyright &copy; rlucioporto.com </small>
          <small>La ciencia, una luz en la oscuridad.</small>
          <button type="button" className="btn btn-link text-white-50 p-0 border-0" onClick={goToLogin}>Administración</button>
        </div>
      </footer>
    )
}